/** THALIA Drones UI: badge, Humans vs Drones counter, rules/FAQ. Test FRAME only. */
import { useEffect, useState } from 'react';
import { useDrones, droneContract, modeLabels } from '../utils/drones';
import { DRONE_FAQ, DRONE_TAG, DRONE_HUMAN_CAP } from '../config/drones';

/** Colored "🤖 NAME · THALIA Drone" pill; renders nothing for humans. */
export function DroneBadge({ address, compact = false }: { address?: string | null; compact?: boolean }) {
  const { droneOf } = useDrones();
  const d = droneOf(address);
  if (!d) return null;
  return (
    <span className="drone-badge" style={{ borderColor: d.color, color: d.color }} title={`${d.name} is a ${DRONE_TAG}: house-run, can never win`} data-testid="drone-badge">
      🤖{compact ? '' : ` ${d.name}`} <small>{DRONE_TAG}</small>
    </span>
  );
}

/** Live counter for the current round. Hidden until the on-chain drone rules are on. */
export function HumansVsDrones({ roundId, refresh }: { roundId: number; refresh?: number }) {
  const { enabled } = useDrones();
  const [h, setH] = useState<{ humans: number; drones: number } | null>(null);
  const [mode, setMode] = useState(0);
  useEffect(() => {
    if (!enabled || !roundId) return;
    let live = true;
    const c = droneContract();
    c.roundHumans(roundId)
      .then((r: any) => { if (live) setH({ humans: Number(r.humans ?? r[0]), drones: Number(r.drones ?? r[1]) }); })
      .catch(() => { /* view not cut in */ });
    c.roundMode(roundId).then((m: any) => { if (live) setMode(Number(m)); }).catch(() => { /* Phase 2.8 not cut in */ });
    return () => { live = false; };
  }, [enabled, roundId, refresh]);
  if (!enabled || !h) return null;
  const pace = Math.max(0, 1 - h.humans / DRONE_HUMAN_CAP);
  return (
    <div className="hvd s12" data-testid="humans-vs-drones">
      <div className="hvd-side"><b>{h.humans}</b><span>Humans</span></div>
      <div className="hvd-mid">vs</div>
      <div className="hvd-side drone"><b>{h.drones}</b><span>🤖 Drones</span></div>
      {mode > 0 && (
        <div className="hvd-mode" data-testid="round-mode">
          {modeLabels(mode).map((l) => <span key={l} className={`pill mode-${l.toLowerCase()}`}>{l === 'Finale' ? '👑 ' : ''}{l}</span>)}
          {mode & 1 ? <small> VEX, THALIA's commander, may buy this round. It still can never win.</small> : null}
        </div>
      )}
      <div className="hvd-note">{pace > 0 ? `Drones at ${Math.round(pace * 100)}% pace. Every human slows them down; they stop at ${DRONE_HUMAN_CAP}.` : 'Enough humans: the drones have stood down.'} Drones never win.</div>
    </div>
  );
}

export function DronesFaq() {
  const { enabled } = useDrones();
  return (
    <div className="drones-faq" id="drones" data-testid="drones-faq">
      <h3>🤖 THALIA Drones <span className={`pill ${enabled ? 'live' : 'coming'}`}>{enabled ? 'live' : 'coming'}</span></h3>
      <dl>
        {DRONE_FAQ.map((f) => (<div key={f.q}><dt>{f.q}</dt><dd>{f.a}</dd></div>))}
      </dl>
    </div>
  );
}
